import { parse } from 'marked';
import DOMPurify from 'dompurify';
import React from 'react';

export function MessageMarkdown({ content }) {
  const html = DOMPurify.sanitize(parse(content, { mangle: false, headerIds: false }) as string);

  return (
    <div
      className="markdown"
      style={{ wordBreak: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
